<button mat-raised-button class="mat-raised-button-go-back" [disabled]="inputDisabled" onclick="this.blur()">
    <div class="inf-button-go-back">
        <mat-icon class="icon-button-go-back" role="img" aria-hidden="true">{{ inputIcon.toLowerCase() }}</mat-icon>
        <span>{{ inputText }}</span>
    </div>
</button>